import firebase from "firebase/app";
import { db } from "../firebase";
import { CareersJob, CAREERS_COLLECTION, WithID, CAREERS_APPLICATIONS_COLLECTION, CareerApplication } from "../../types/db";
import { applyVariablesToQuery, QueryVariables } from "../db";

const getCareersCollectionRef = () => {
    return db.collection(CAREERS_COLLECTION);
}

/** Get a list of job posts */
export const getCareerPosts = async (variables?: QueryVariables) => {
    let query: firebase.firestore.Query<firebase.firestore.DocumentData> = getCareersCollectionRef();
    query = applyVariablesToQuery(query, variables);

    const data = await query.get();

    return data.docs.map(doc => ({
        ...doc,//full doc for pagination
        ...(doc.data() as CareersJob),
        id: doc.id,//id to redirect to details
    })) as WithID<CareersJob, string>[];
}

/** Get the basic info of a job post */
export const getCareerDetails = async (jobId: string) => {
    const data = await getCareersCollectionRef()
        .doc(jobId)
        .get();

    return data.data() as CareersJob;
}

/** Add a job post */
export const addCareerJob = (job: CareersJob) => {
    return getCareersCollectionRef()
        .add(job);
}

/** Update an existing job post */
export const updateCareerJob = (jobId: string, jobData: Partial<CareersJob>) => {
    return getCareersCollectionRef()
        .doc(jobId)
        .update(jobData);
}

/** Delete an existing job post */
export const deleteCareerJob = (jobId: string) => {
    return getCareersCollectionRef()
        .doc(jobId)
        .delete();
}

/** Get the collection of application ref for a specific job post */
const getCareerApplicationsCollectionRef = (jobId: string) => {
    return getCareersCollectionRef()
        .doc(jobId)
        .collection(CAREERS_APPLICATIONS_COLLECTION);
}

/** Add an application to a job post */
export const addCareerApplication = (jobId: string, candidate: Omit<CareerApplication, 'timestamp'>) => {
    return getCareerApplicationsCollectionRef(jobId)
        .add({
            ...candidate,
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
        })
}
